webpackJsonp([1],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(12);
	var util = __webpack_require__(15);
	var doAjax = __webpack_require__(19);
	
	function doIt(action, value, cb) {
	  var data = {
	    tid: topicId
	  };
	  data[action] = value;
	
	  doAjax(action, data, cb);
	}
	
	var pageConfig = window.pageConfig;
	var topicId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
	var wrapper = $('.topic-edit-wrap');
	var unlock = pageConfig.topic.unlock;
	var top = pageConfig.topic.top;
	var essence = pageConfig.topic.essence;
	var uid = util.getUid();
	var isMyself = pageConfig.user.id === uid;
	var star = pageConfig.topic.collectors.some(function (item) {
	  return item === uid;
	});
	
	//star = isMyself ? '' : `<i title="${i18n(star ? 'unstar' : 'star')}" class="star ${star ? '' : 'empty'} icon"></i>`;
	
	var icons = '<i title="' + i18n(unlock ? 'lock' : 'unlock') + '" class=" lock ' + (unlock ? 'unlock' : '') + ' icon"></i>\n  <i title="' + i18n(top ? 'untop' : 'top') + '" class="arrow circle up ' + (top ? '' : 'outline') + ' icon"></i>\n  <i title="' + i18n(essence ? 'unessence' : 'essence') + '" class="plus square icon  ' + (essence ? '' : 'outline') + ' icon"></i>\n  <i title="' + i18n('common.remove') + '" class="trash outline icon"></i>\n';
	
	wrapper.append(icons);
	
	wrapper.on('click', '.lock', function () {
	  // 锁定
	  var self = this;
	  doIt('lock', $(this).hasClass('unlock'), function () {
	    $(self).toggleClass('unlock');
	    var locked = !$(self).hasClass('unlock');
	    $(self).parent().children('.edit').toggleClass('disabled', locked);
	    $('.add-comment').toggleClass('disabled', locked);
	    $('.comment-list .comment-edit-wrap').find('.icon').toggleClass('disabled', locked);
	    $(self).prop('title', i18n(locked ? 'unlock' : 'lock'));
	  });
	}).on('click', '.arrow', function () {
	  // 置顶
	  var self = this;
	  doIt('top', $(this).hasClass('outline'), function () {
	    $(self).toggleClass('outline');
	    $(self).prop('title', i18n($(self).hasClass('outline') ? 'top' : 'untop'));
	  });
	}).on('click', '.square', function () {
	  // 精华
	  var self = this;
	  doIt('essence', $(this).hasClass('outline'), function () {
	    $(self).toggleClass('outline');
	    $(self).prop('title', i18n($(self).hasClass('outline') ? 'essence' : 'unessence'));
	  });
	}).on('click', '.star', function () {
	  // 收藏
	  var self = this;
	  doIt('collect', $(this).hasClass('empty'), function () {
	    $(self).toggleClass('empty');
	    $(self).prop('title', i18n($(self).hasClass('empty') ? 'star' : 'unstar'));
	  });
	}).on('click', '.trash', function () {
	  //删除帖子
	  util.showConfirm(i18n('confirm.remove.topic'), function () {
	    doAjax('remove', { tid: topicId }, function (res) {
	      window.location.href = pageConfig.projectName + '/';
	    });
	  }, function () {});
	});

/***/ })

});


// WEBPACK FOOTER //
// admin.js